import { Tabs, Tab, Box, Paper } from '@mui/material';
import ComplexData from './ComplexData';
import ComplexChilds from './ComplexChilds';
import ComplexPhotos from './ComplexPhotos';
import ComplexGraphs from './ComplexGraphs';
import ComplexStatistic from './ComplexStatistic';
import ComplexViewSkatS from './ComplexViewSkatS';
import ComplexArchive from './ComplexArchive';
import ComplexAuditLog from './ComplexAuditLog';
import ComplexPautina from './ComplexPautina';
import ComplexVideo from './ComplexVideo';
import ComplexDataXml from './ComplexDataXml';
// import '../../../styles/ModalContent.css';
import { useState } from 'react';

// Импорт иконок
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DatasetIcon from '@mui/icons-material/Dataset';
import BarChartIcon from '@mui/icons-material/BarChart';
import ImageIcon from '@mui/icons-material/Image';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import HistoryIcon from '@mui/icons-material/History';
import WebIcon from '@mui/icons-material/Web';
import VideocamIcon from '@mui/icons-material/Videocam';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import StorageIcon from '@mui/icons-material/Storage';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            sx={{
                width: '100%',
                height: '100%',
                overflowY: 'hidden',
                backgroundColor: 'var(--background-paper)'
            }}
            {...other}
        >
            {value === index && (children)}
            {/* <Box sx={{
                    p: 1,
                    width: '100%', 
                    height: '100%'
                }}>
                    {children}
                </Box>
            )} */}
        </Box >
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Конфигурация табов для разных типов
const getTabsConfig = (type, host = null) => {
    // Проверяем, есть ли тег type = skats для speed хостов
    const isSkats = host?.tags?.find(t => t.tag === 'type' && t.value === 'skat-s');
    const isCyclop = host?.tags?.find(t => t.tag === 'type' && t.value === 'cyclop');
    console.log(host, isSkats)
    switch (type) {
        case 'crossroad':
            return [
                { label: 'Состав перекрестка', component: 'childs', icon: AccountTreeIcon },
                { label: 'Данные', component: 'data', icon: DatasetIcon },
                { label: 'data.xml', component: 'dataxml', icon: StorageIcon },
                { label: 'Графики', component: 'graphs', icon: BarChartIcon },
                { label: 'Фото', component: 'images', icon: ImageIcon },
                { label: 'Видео', component: 'video', icon: VideocamIcon },
                { label: 'Статистика', component: 'statistic', icon: AssessmentIcon },
                { label: 'Коллажи', component: 'collage', icon: PhotoLibraryIcon },
                { label: 'Паутина', component: 'pautina', icon: WebIcon },
                { label: 'Журнал', component: 'auditlog', icon: HistoryIcon }
            ];
        case 'speed':
            // Для speed с тегом type=skats добавляем вкладку СКАТ-С
            const speedTabs = [
                { label: 'Данные', component: 'data', icon: DatasetIcon },
                { label: 'Графики', component: 'graphs', icon: BarChartIcon },
                { label: 'Фото', component: 'images', icon: ImageIcon },
                { label: 'Статистика', component: 'statistic', icon: AssessmentIcon },
                { label: 'Коллажи', component: 'collage', icon: PhotoLibraryIcon },
                { label: 'Паутина', component: 'pautina', icon: WebIcon },
                { label: 'Журнал', component: 'auditlog', icon: HistoryIcon }
            ];
            if (isSkats) {
                // Добавляем вкладку СКАТ-С после "Фото"
                speedTabs.splice(3, 0, { label: 'СКАТ-С', component: 'viewskats', icon: CameraAltIcon });
            }
            if (isCyclop) {
                // Добавляем вкладку Видео после "Фото"
                speedTabs.splice(3, 0, { label: 'Видео', component: 'video', icon: VideocamIcon });
            }
            return speedTabs;
        case 'parking':
            return [
                { label: 'Данные', component: 'data', icon: DatasetIcon },
                { label: 'Графики', component: 'graphs', icon: BarChartIcon },
                { label: 'Фото', component: 'images', icon: ImageIcon },
                { label: 'Статистика', component: 'statistic', icon: AssessmentIcon },
                { label: 'Коллажи', component: 'collage', icon: PhotoLibraryIcon },
                { label: 'Паутина', component: 'pautina', icon: WebIcon },
                { label: 'Журнал', component: 'auditlog', icon: HistoryIcon }
            ];
        case 'vgk':
            return [
                { label: 'Данные', component: 'data', icon: DatasetIcon },
                { label: 'Графики', component: 'graphs', icon: BarChartIcon },
                { label: 'Кадры', component: 'images', icon: ImageIcon },
                { label: 'Статистика', component: 'statistic', icon: AssessmentIcon },
                { label: 'Коллажи', component: 'collage', icon: PhotoLibraryIcon },
                { label: 'Паутина', component: 'pautina', icon: WebIcon },
                { label: 'Журнал', component: 'auditlog', icon: HistoryIcon }
            ];
        case 'others':
            return [
                { label: 'Паутина', component: 'pautina', icon: WebIcon }
            ];
        default:
            return [
                { label: 'Данные', component: 'data', icon: DatasetIcon },
                { label: 'Графики', component: 'graphs', icon: BarChartIcon },
                { label: 'Статистика', component: 'statistic', icon: AssessmentIcon },
                { label: 'Журнал', component: 'auditlog', icon: HistoryIcon }
            ];
    }
};

// Рендер компонента по типу
const renderTabComponent = (component, props, hostType) => {
    switch (component) {
        case 'childs':
            return <ComplexChilds host={props.host} hostType={hostType} />;
        case 'data':
            return <ComplexData host={props.host} hostType={hostType} />;
        case 'dataxml':
            return <ComplexDataXml host={props.host} hostType={hostType} />;
        case 'graphs':
            return <ComplexGraphs host={props.host} hostType={hostType} />;
        case 'images':
            return <ComplexPhotos host={props.host} style={props.style} hostType={hostType} />;
        case 'video':
            return <ComplexVideo host={props.host} hostType={hostType} />;
        case 'statistic':
            return <ComplexStatistic host={props.host} style={props.style} hostType={hostType} />;
        case 'viewskats':
            return <ComplexViewSkatS complex={props.host} type={hostType} />;
        case 'collage':
            return <ComplexArchive host={props.host} hostType={hostType} />;
        case 'auditlog':
            return <ComplexAuditLog host={props.host} hostType={hostType} />;
        case 'pautina':
            return <ComplexPautina host={props.host} hostType={hostType} />;
        default:
            return null;
    }
};

const ModalContent = props => {
    const { hostType = 'default', host } = props;
    console.log(hostType)
    const [value, setValue] = useState(0);
    const tabsConfig = getTabsConfig(hostType, host);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Логирование для отладки
    console.log(props);
    if (hostType !== 'crossroad') {
        const typeTag = props.host.tags?.find((c) => c.tag === 'type');
        console.log(typeTag);
    }

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            backgroundColor: 'var(--background-paper)'
        }}>
            <Box sx={{
                backgroundColor: 'var(--background-default)',
                borderBottom: '1px solid var(--border-default)',
                px: { xs: 1, md: 1.5 },
                pt: 0,
            }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="content tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        minHeight: { xs: '28px', md: '32px' },
                        '& .MuiTabs-indicator': {
                            height: { xs: 2, md: 3 },
                            borderRadius: '3px 3px 0 0',
                        },
                        '& .MuiTabs-scrollButtons': {
                            width: { xs: '24px', md: '32px' },
                            '& .MuiSvgIcon-root': {
                                fontSize: { xs: '16px', md: '20px' },
                            }
                        },
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: { xs: '0.7rem', md: '0.85rem' },
                            minHeight: { xs: '28px', md: '32px' },
                            padding: { xs: '4px 8px', md: '8px 12px' },
                            color: 'var(--text-secondary)',
                            transition: 'all 0.15s ease',
                            '&:hover': {
                                color: 'var(--primary-color)',
                                backgroundColor: 'var(--hover-bg)',
                            },
                            '&.Mui-selected': {
                                color: 'var(--primary-color)',
                                fontWeight: 700,
                            }
                        }
                    }}
                >
                    {tabsConfig.map((tab, index) => {
                        const IconComponent = tab.icon;
                        return (
                            <Tab
                                key={index}
                                label={
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: { xs: 0.5, md: 1 }
                                    }}>
                                        <IconComponent sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }} />
                                        {tab.label}
                                    </Box>
                                }
                                {...a11yProps(index)}
                            />
                        );
                    })}
                </Tabs>
            </Box>

            {tabsConfig.map((tab, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {renderTabComponent(tab.component, props, hostType)}
                </TabPanel>
            ))}
        </Box>
    );
};

export default ModalContent; 